// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-containerQR {
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(200px, 1fr)
  ); /* Responsive grid */
  gap: 20px; /* Increased gap for better separation */
  padding: 20px;
  border: 1px solid #000;
  font-family: Arial, sans-serif;
  page-break-after: always; /* Force a page break after each label container */
}

.label-sectionQR {
  border: 1px solid #000;
  padding: 10px;
  background-color: #f9f9f9; /* Light background for contrast */
  border-radius: 5px; /* Rounded corners */
}

.from-address,
.to-address {
  display: flex;
  flex-direction: column;
  justify-content: center;
  grid-column: span 2; /* Adjusted for better layout */
}

.barcode {
  grid-column: span 2;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.qr-code {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0px;
  padding: 5px;
}

.hereClass {
  display: flex;
  justify-content: space-between;
}

.spaceForQRHeadingAndButton {
  display: flex;
  justify-content: space-between;
}

.printQR {
  height: 25px;
  width: 70px;
  margin-left: 10px;
  background-color: white;
  border: 1px solid lightgray;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;
}

.printQR:hover {
  background-color: #f0f0f0; /* Hover effect */
  border-color: #ccc;
}

p {
  margin-left: 10px;
  font-size: 14px; /* Consistent font size */
}

@media print {
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .label-containerQR {
    grid-template-columns: 1fr; /* Ensure each order is full-width for printing */
    gap: 10px;
    page-break-after: always; /* Ensure each order prints on a separate page */
  }

  .printQR {
    display: none; /* Hide print button when printing */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/OrderLabel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;;;GAGC,EAAE,oBAAoB;EACvB,SAAS,EAAE,wCAAwC;EACnD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB,EAAE,kDAAkD;AAC9E;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB,EAAE,kCAAkC;EAC7D,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EAKvB,mBAAmB,EAAE,+BAA+B;AAJtD;;AAOA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe,EAAE,yBAAyB;AAC5C;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,0BAA0B,EAAE,iDAAiD;IAC7E,SAAS;IACT,wBAAwB,EAAE,gDAAgD;EAC5E;;EAEA;IACE,aAAa,EAAE,oCAAoC;EACrD;AACF","sourcesContent":[".label-containerQR {\r\n  display: grid;\r\n  grid-template-columns: repeat(\r\n    auto-fill,\r\n    minmax(200px, 1fr)\r\n  ); /* Responsive grid */\r\n  gap: 20px; /* Increased gap for better separation */\r\n  padding: 20px;\r\n  border: 1px solid #000;\r\n  font-family: Arial, sans-serif;\r\n  page-break-after: always; /* Force a page break after each label container */\r\n}\r\n\r\n.label-sectionQR {\r\n  border: 1px solid #000;\r\n  padding: 10px;\r\n  background-color: #f9f9f9; /* Light background for contrast */\r\n  border-radius: 5px; /* Rounded corners */\r\n}\r\n\r\n.from-address,\r\n.to-address {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.from-address,\r\n.to-address {\r\n  grid-column: span 2; /* Adjusted for better layout */\r\n}\r\n\r\n.barcode {\r\n  grid-column: span 2;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.qr-code {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 0px;\r\n  padding: 5px;\r\n}\r\n\r\n.hereClass {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.spaceForQRHeadingAndButton {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.printQR {\r\n  height: 25px;\r\n  width: 70px;\r\n  margin-left: 10px;\r\n  background-color: white;\r\n  border: 1px solid lightgray;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s, border-color 0.3s;\r\n}\r\n\r\n.printQR:hover {\r\n  background-color: #f0f0f0; /* Hover effect */\r\n  border-color: #ccc;\r\n}\r\n\r\np {\r\n  margin-left: 10px;\r\n  font-size: 14px; /* Consistent font size */\r\n}\r\n\r\n@media print {\r\n  body {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .label-containerQR {\r\n    grid-template-columns: 1fr; /* Ensure each order is full-width for printing */\r\n    gap: 10px;\r\n    page-break-after: always; /* Ensure each order prints on a separate page */\r\n  }\r\n\r\n  .printQR {\r\n    display: none; /* Hide print button when printing */\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
